import get from 'lodash/get';
import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_SERVICEDESK_FEATURES } from '../common/constants.tsx';
import type { FeaturesData } from '../types.tsx';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-practice-features", jiraSpaEntry: "async-resource-servicedesk-practice-features" */ '../controllers/get-data'
	);

const ONE_DAY_IN_MILLIS = 60 * 60 * 1000 * 24;

export const featuresResource = createResource<FeaturesData | null>({
	type: RESOURCE_TYPE_SERVICEDESK_FEATURES,
	getKey: ({ match, query }) =>
		// projectKey from url path or browse/{issueKey}
		getProjectKeyId(match, query).projectKey || get(match, 'params.issueKey', '').split('-')[0],
	getDataLoader,
	maxAge: ONE_DAY_IN_MILLIS,
});
